module.exports = __webpack_public_path__ + "img/Jasper - Greeting.ba744776.png";